import { render, staticRenderFns } from "./WarehouseIndex.vue?vue&type=template&id=1c077e1c&"
import script from "./WarehouseIndex.vue?vue&type=script&lang=js&"
export * from "./WarehouseIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports